

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
  faCircleXmark,
  faBars,
} from "@fortawesome/free-solid-svg-icons";
import MobileService from "./MobileService";
import MobileProduct from "./MobileProduct";
import Logo from "../../../assets/images/logo.png";

const MobileNav = ({ menuOpen, setMenuOpen }) => {
  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleCloseMobileNav = () => {
    setMenuOpen(false);
    setActiveDropdown(null);
  };

  const toggleDropdown = (dropdown) => {
    setActiveDropdown((prev) => (prev === dropdown ? null : dropdown));
  };

  return (
    <div className="bg-white w-full h-[80px] shadow z-50 flex justify-center">
      <div className="flex justify-between items-center w-full px-2.5 py-3">
        <Link to="/" className="flex items-center">
          <img src={Logo} alt="Logo" className="h-8 w-auto" />
        </Link>
        <div className="flex items-center">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-[#263A98]"
          >
            <FontAwesomeIcon icon={faBars} className="text-xl" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="fixed inset-0 h-screen py-2 bg-white z-[9999] overflow-y-auto">
          <div className="flex justify-between items-center px-2.5 py-3 border-b">
            <Link
              to="/"
              onClick={handleCloseMobileNav}
              className="flex items-center"
            >
              <img src={Logo} alt="Logo" className="h-8 w-auto" />
            </Link>
            <button onClick={handleCloseMobileNav} className="text-main">
              <FontAwesomeIcon icon={faCircleXmark} className="text-xl" />
            </button>
          </div>

          <ul className="space-y-2 px-2 py-2 text-base font-medium text-gray-800">
            <li>
              <Link
                to="/"
                onClick={handleCloseMobileNav}
                className="block px-3 py-2 hover:bg-main hover:text-white rounded-md"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about-us"
                onClick={handleCloseMobileNav}
                className="block px-3 py-2 hover:bg-main hover:text-white rounded-md"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/feature"
                onClick={handleCloseMobileNav}
                className="block px-3 py-2 hover:bg-main hover:text-white rounded-md"
              >
                Features
              </Link>
            </li>

            <li className="relative">
              <div
                onClick={() => toggleDropdown("product")}
                className="flex justify-between items-center cursor-pointer hover:bg-main hover:text-white rounded-md px-3 py-2 transition-all duration-300"
              >
                <span>Product</span>
                <FontAwesomeIcon
                  icon={
                    activeDropdown === "product" ? faChevronUp : faChevronDown
                  }
                  className="text-sm"
                />
              </div>
              {activeDropdown === "product" && (
                <MobileProduct handleCloseMobileNav={handleCloseMobileNav} />
              )}
            </li>

            <li>
              <Link
                to="/our-team"
                onClick={handleCloseMobileNav}
                className="block px-3 py-2 hover:bg-main hover:text-white rounded-md"
              >
                Our Team
              </Link>
            </li>

            <li>
              <Link
                to="/career"
                onClick={handleCloseMobileNav}
                className="block px-3 py-2 hover:bg-main hover:text-white rounded-md"
              >
                Career
              </Link>
            </li>

            <li className="relative">
              <div
                onClick={() => toggleDropdown("service")}
                className="flex justify-between items-center cursor-pointer hover:bg-main hover:text-white rounded-md px-3 py-2 transition-all duration-300"
              >
                <span>Services</span>
                <FontAwesomeIcon
                  icon={
                    activeDropdown === "service" ? faChevronUp : faChevronDown
                  }
                  className="text-sm"
                />
              </div>
              {activeDropdown === "service" && (
                <MobileService handleCloseMobileNav={handleCloseMobileNav} />
              )}
            </li>

            <li>
              <Link
                to="/contact-us"
                onClick={handleCloseMobileNav}
                className="block px-3 py-2 hover:bg-main hover:text-white rounded-md"
              >
                Contact
              </Link>
            </li>

            <li>
              <Link
                to="/payment"
                onClick={handleCloseMobileNav}
                className="block px-3 py-2 hover:bg-main hover:text-white rounded-md"
              >
                Payment
              </Link>
            </li>

            <li>
              <a
                href="https://ivr.deetyasoft.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-main text-white no-underline py-2 px-3 rounded-full text-sm hover:bg-blue-900 transition-all duration-300"
              >
                Request A Call Back
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default MobileNav;
